import { RootState } from '@store/redux.store'
import type { TaskTrackerState } from '../index'
import { createEmptyBoardStickerFiltersBoardState } from './boardStickerFilters.state.utils'

type AppState = RootState & {
  taskTracker: TaskTrackerState
}

export const selectTaskTrackerBoardStickerFilters = (
  state: AppState,
  boardId: number | null,
) => {
  if (boardId == null) return createEmptyBoardStickerFiltersBoardState()
  return (
    state.taskTracker.boardStickerFilters.byBoardId[boardId] ??
    createEmptyBoardStickerFiltersBoardState()
  )
}
